import React from 'react';

export const IPhoneMockup = ({ videoSrc }) => {
  return (
    <div className="iphone-mockup" data-testid="iphone-mockup">
      {/* iPhone frame */}
      <div className="iphone-frame">
        {/* Notch */}
        <div className="iphone-notch">
          <div className="iphone-notch-camera"></div>
        </div>
        {/* Screen */}
        <div className="iphone-screen">
          <video
            data-testid="app-demo-video"
            src={videoSrc}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '0',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default IPhoneMockup;
